import React from 'react';
import { Icon } from 'antd';
import { connect } from 'dva';
import styles from './Index.less';

@connect(({ AddressBook }) => ({
  chargeTarget: AddressBook.chargeTarget,
}))
export default class SelectedPart extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete(node) {
    this.props.dispatch({
      type: 'AddressBook/setSelectedUser',
      payload: {
        option: 'delete',
        node,
      },
    });
    // 更新树组件默认选中的key集合
    setTimeout(() => {
      const { selected, addressBook, exceptNodes } = this.props.chargeTarget;
      this.props.dispatch({
        type: 'AddressBook/fetchCheckedKey',
        selectedList: selected,
        treeData: addressBook,
        exceptNodes,
      });
    }, 0);
  }

  findExceptNodes(id) {
    const { exceptNodes } = this.props.chargeTarget;
    let result = [];

    for (const key in exceptNodes) {
      if (id === key) {
        result = exceptNodes[key];
      }
    }

    return result;
  }

  // 渲染被排除在外的人员名单
  renderExceptNodes(id) {
    const list = this.findExceptNodes(id);

    if (!list.length) {
      return null;
    }
    return (
      <span>
        （除了{list.map((item, index, arr) => {
          return (
            <span key={item.id}>
              {item.name}
              {index === arr.length - 1 ? '' : '，'}
            </span>
          );
        })}）
      </span>
    );
  }

  render() {
    const { selected } = this.props.chargeTarget;
    const itemList = selected.map(item => {
      return (
        <div key={item.id} className={styles['item-container']}>
          <span>{item.name}</span>
          {this.renderExceptNodes(item.id)}
          <Icon
            type="close-circle-o"
            className={styles['del-icon']}
            onClick={this.handleDelete.bind(this, item)}
          />
        </div>
      );
    });

    return <div className={styles['selected-contanier']}>{itemList}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components_business/Address/SelectedPart/Index.js